var _defs, _path, _path2, _path3, _g, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-ve",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "d",
    transform: "translate(0 -36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "#fff",
    d: "M0-5-1.5-.2l2.8.9z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 180,
    height: 120,
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: 180,
    height: 120,
    transform: "rotate(72)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: 180,
    height: 120,
    transform: "rotate(-72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: 180,
    height: 120,
    transform: "rotate(144)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cf142b",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00247d",
    d: "M0 0h512v341.3H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M0 0h512v170.7H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f",
    transform: "translate(256.3 358.4) scale(4.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: 180,
    height: 120,
    transform: "rotate(10)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: 180,
    height: 120,
    transform: "rotate(30)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    width: 180,
    height: 120,
    transform: "rotate(40)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    width: 180,
    height: 120,
    transform: "rotate(-80 256.3 358.4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVe);
export default __webpack_public_path__ + "static/media/ve.ede15c2583ace31d82494dd839755767.svg";
export { ForwardRef as ReactComponent };